module.exports = __webpack_public_path__ + "static/media/bookIcon.0dccb484.svg";